import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@modules/shared/shared.module';
import { UiModule } from '@modules/ui/ui.module';

import { LegalRoutingModule } from './legal-routing.module';
import { LegalComponent } from './legal.component';
import { SettingComponent } from './setting.component';

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule, UiModule, LegalComponent, SettingComponent],
  exports: [LegalRoutingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LegalModule {}
